<!--Changing Weapon Runes-->
<div class="list-item" *ngIf="get_IsRuneItem() && (item.moddable || customItemStore)">
    <div class="newrow" *ngIf="get_IsWeaponRuneItem()">
        <strong>Potency rune</strong>
        <ng-container *ngFor="let previousRune of [item.potencyRune]; trackBy:trackByIndex;">
            <select [(ngModel)]="item.potencyRune" (ngModelChange)="on_WeaponRuneChange('potency', previousRune)">
                <option *ngFor="let potency of get_WeaponPotencyRunes(); trackBy:trackByIndex;"
                    [ngValue]="potency.potency" [disabled]="potency.disabled" title="{{get_Title(potency.rune)}}">
                    {{item.get_Potency(potency.potency)}}</option>
            </select>
        </ng-container>
    </div>
    <div class="newrow" *ngIf="get_IsArmorRuneItem()">
        <strong>Potency rune</strong>
        <ng-container *ngFor="let previousRune of [item.potencyRune]; trackBy:trackByIndex;">
            <select [(ngModel)]="item.potencyRune" (ngModelChange)="on_ArmorRuneChange('potency', previousRune)">
                <option *ngFor="let potency of get_ArmorPotencyRunes(); trackBy:trackByIndex;"
                    [ngValue]="potency.potency" [disabled]="potency.disabled" title="{{get_Title(potency.rune)}}">
                    {{item.get_Potency(potency.potency)}}</option>
            </select>
        </ng-container>
    </div>
    <div class="newrow" *ngIf="item.potencyRune > 0 && get_IsWeaponRuneItem()">
        <strong>Striking rune</strong>
        <ng-container *ngFor="let previousRune of [item.strikingRune]; trackBy:trackByIndex;">
            <select [(ngModel)]="item.strikingRune" (ngModelChange)="on_WeaponRuneChange('striking', previousRune)">
                <option *ngFor="let striking of get_StrikingRunes(); trackBy:trackByIndex;"
                    [ngValue]="striking.striking" [disabled]="striking.disabled" title="{{get_Title(striking.rune)}}">
                    {{item.get_Striking(striking.striking)}}</option>
            </select>
        </ng-container>
    </div>
    <div class="newrow" *ngIf="item.potencyRune > 0 && get_IsArmorRuneItem()">
        <strong>Resilient rune</strong>
        <ng-container *ngFor="let previousRune of [item.resilientRune]; trackBy:trackByIndex;">
            <select [(ngModel)]="item.resilientRune" (ngModelChange)="on_ArmorRuneChange('resilient', previousRune)">
                <option *ngFor="let resilient of get_ResilientRunes(); trackBy:trackByIndex;"
                    [ngValue]="resilient.resilient" [disabled]="resilient.disabled"
                    title="{{get_Title(resilient.rune)}}">
                    {{item.get_Resilient(resilient.resilient)}}</option>
            </select>
        </ng-container>
    </div>
    <ng-container *ngIf="item.potencyRune > 0 && get_IsWeaponRuneItem()">
        <div class="newrow" *ngFor="let index of get_PropertyRunes(); trackBy:trackByIndex;">
            <strong *ngIf="index === 0">Property runes</strong>
            <span *ngIf="index !== 0">&nbsp;</span>
            <select [(ngModel)]="newPropertyRune[index]" (ngModelChange)="add_WeaponPropertyRune(index)"
                [disabled]="!item.propertyRunes[index-1] && index > 0">
                <ng-container
                    *ngFor="let rune of get_InitialPropertyRunes(index); let initialRuneIndex = index; trackBy:trackByIndex;">
                    <option [ngValue]="rune" *ngIf="initialRuneIndex === 0" [selected]=!item.propertyRunes[index]>
                        <!--Blank option to deselect-->
                    </option>
                    <optgroup *ngIf="initialRuneIndex === 1" label="Current rune">
                        <option [ngValue]="rune">
                            {{rune.rune.name}}
                        </option>
                    </optgroup>
                </ng-container>
                <ng-container *ngFor="let inv of get_Inventories(); trackBy:trackByIndex;">
                    <optgroup label="{{itemStore ? 'Available runes' : inv.get_Name(characterService)}}"
                        *ngIf="get_WeaponPropertyRunes(index, inv).length">
                        <option *ngFor="let rune of get_WeaponPropertyRunes(index, inv); trackBy:trackByIndex;"
                            [ngValue]="rune" [disabled]="rune.disabled" title="{{get_Title(rune.rune)}}">
                            {{rune.rune.amount > 1 ? rune.rune.amount+" " :
                            ""}}{{rune.rune.name}}{{get_RuneCooldown(rune.rune)}}
                        </option>
                    </optgroup>
                </ng-container>
            </select>
        </div>
    </ng-container>
    <ng-container *ngIf="item.potencyRune > 0 && get_IsArmorRuneItem()">
        <div class="newrow" *ngFor="let index of get_PropertyRunes(); trackBy:trackByIndex;">
            <strong *ngIf="index === 0">Property runes</strong>
            <span *ngIf="index !== 0">&nbsp;</span>
            <select [(ngModel)]="newPropertyRune[index]" (ngModelChange)="add_ArmorPropertyRune(index)"
                [disabled]="!item.propertyRunes[index-1] && index > 0">
                <ng-container
                    *ngFor="let rune of get_InitialPropertyRunes(index); let initialRuneIndex = index; trackBy:trackByIndex;">
                    <option [ngValue]="rune" *ngIf="initialRuneIndex === 0" [selected]=!item.propertyRunes[index]>
                        <!--Blank option to deselect-->
                    </option>
                    <optgroup *ngIf="initialRuneIndex === 1" label="Current rune">
                        <option [ngValue]="rune">
                            {{rune.rune.name}}
                        </option>
                    </optgroup>
                </ng-container>
                <ng-container *ngFor="let inv of get_Inventories(); trackBy:trackByIndex;">
                    <optgroup label="{{itemStore ? 'Available runes' : inv.get_Name(characterService)}}"
                        *ngIf="get_ArmorPropertyRunes(index, inv).length">
                        <option *ngFor="let rune of get_ArmorPropertyRunes(index, inv); trackBy:trackByIndex;"
                            [ngValue]="rune" [disabled]="rune.disabled" title="{{get_Title(rune.rune)}}">
                            {{rune.rune.amount > 1 ? rune.rune.amount+" " :
                            ""}}{{rune.rune.name}}{{get_RuneCooldown(rune.rune)}}
                        </option>
                    </optgroup>
                </ng-container>
            </select>
        </div>
    </ng-container>
</div>
